import { type AuthCtaMode } from "~/feature/auth/type";

const SIGN_UP_PARAM = "sign-up";
const SIGN_IN_PARAM = "sign-in";

interface IParsedAuthParam {
  mode: AuthCtaMode;
  cleanedParams: URLSearchParams;
}

const findAuthMode = (searchParams: URLSearchParams): AuthCtaMode | null => {
  if (searchParams.has(SIGN_UP_PARAM)) {
    return "sign-up";
  }
  if (searchParams.has(SIGN_IN_PARAM)) {
    return "sign-in";
  }

  return null;
};

export const parseAuthParam = (
  searchParams: URLSearchParams
): IParsedAuthParam | null => {
  const mode = findAuthMode(searchParams);
  if (!mode) {
    return null;
  }

  const cleanedParams = new URLSearchParams(searchParams);
  cleanedParams.delete(SIGN_UP_PARAM);
  cleanedParams.delete(SIGN_IN_PARAM);

  return { mode, cleanedParams };
};

export const stripAuthParams = (href: string): string => {
  const url = new URL(href);
  url.searchParams.delete(SIGN_UP_PARAM);
  url.searchParams.delete(SIGN_IN_PARAM);

  return url.toString();
};
